import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LoginFeature } from "@/features/auth/LoginFeature";

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  verified: z.boolean().optional(),
});

function LoginPage() {
  const { redirect, verified } = Route.useSearch();
  return <LoginFeature redirectAfterLogin={redirect} emailVerified={verified === true} />;
}

export const Route = createFileRoute("/(auth)/login")({
  validateSearch: loginSearchSchema,
  component: LoginPage,
  staticData: { authorize: false },
});
